import { Node, ROOT_NODE, useEditor } from '@craftjs/core';
import {
	Box,
	Button as MaterialButton,
	Chip,
	Grid,
	Paper
} from '@mui/material';
import { useKeyboard } from 'hooks';
import React from 'react';

const SettingsPanel: React.FC<{}> = () => {
	const { actions, id, name, Settings, isDeletable } = useEditor(
		(state, query) => {
			const currentNodeId = query.getEvent('selected').last();
			if (!currentNodeId) {
				return {};
			}

			const node: Node = state.nodes[currentNodeId];

			return {
				id: currentNodeId,
				name: node?.data.displayName,
				Settings: node?.related?.settings as any,
				isDeletable:
					query.node(currentNodeId).isDeletable() &&
					!node?.data.props.nonDeletable
			};
		}
	);

	const handleDelete = React.useCallback(() => {
		if (id && id !== ROOT_NODE) actions.delete(id);
	}, [actions, id]);

	useKeyboard('Backspace', handleDelete);

	return Settings ? (
		<Box height="100%" data-testid="page-editor-settings-panel">
			<Paper sx={{ minHeight: '100%' }}>
				<Grid
					container
					direction="column"
					spacing={0}
					px={2}
					py={2}
					overflow="hidden"
				>
					<Grid item>
						<Box pb={2}>
							<Grid container alignItems="center">
								<Grid item>
									<Chip size="small" color="primary" label={name} />
								</Grid>
							</Grid>
						</Box>
					</Grid>
					<Settings />
					{isDeletable && (
						<Box marginTop={2}>
							<MaterialButton
								fullWidth
								variant="outlined"
								color="error"
								data-testid="delete-node"
								onClick={handleDelete}
							>
								{intl.tr('button.delete')}
							</MaterialButton>
						</Box>
					)}
				</Grid>
			</Paper>
		</Box>
	) : null;
};

export default SettingsPanel;
